import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { ResourceService, ReflexEnvironment as ENV} from '@smartsoftware/reflex-core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import {
    OrderDetail
} from '../models';

@Injectable()
export class OrderDetail_Service extends ResourceService<OrderDetail> {
    protected servicePath: string = '/Order';

    public ModelType = OrderDetail;

    constructor(
        protected auth: OidcSecurityService,
        protected http: HttpClient,
    ) {
        super(http);
    }
}
